import { render, staticRenderFns } from "./technicalnorm.vue?vue&type=template&id=eaaf3772&scoped=true&"
import script from "./technicalnorm.vue?vue&type=script&lang=js&"
export * from "./technicalnorm.vue?vue&type=script&lang=js&"
import style0 from "./technicalnorm.vue?vue&type=style&index=0&id=eaaf3772&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaaf3772",
  null
  
)

export default component.exports